import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { anfrageService } from '../services/api';
import '../styles/Anfragen.css';

// Zähler pro Stufe der Anfragen-Pipeline fürs Dashboard
function PipelineWidget() {
  const [daten, setDaten] = useState(null);
  useEffect(() => { anfrageService.pipeline().then(setDaten).catch(() => setDaten(null)); }, []);
  if (!daten) return null;
  const zeigen = daten.status.filter(s => !['Gebucht', 'Abgesagt'].includes(s));
  return (
    <div className="dashboard-section">
      <div className="section-header flex-between mb-2">
        <h2>Anfragen – was ist zu tun?</h2>
        <Link to="/anfragen" className="btn btn-secondary">Alle Anfragen</Link>
      </div>
      <div className="pipeline-widget">
        {zeigen.map(s => (
          <Link key={s} to={`/anfragen?status=${encodeURIComponent(s)}`}>
            <strong>{daten.counts[s] || 0}</strong>
            <span>{s}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default PipelineWidget;
